import { render, staticRenderFns } from "./objectAttributeReport.vue?vue&type=template&id=1b6b69b2&scoped=true"
import script from "./objectAttributeReport.vue?vue&type=script&lang=js"
export * from "./objectAttributeReport.vue?vue&type=script&lang=js"
import style0 from "./objectAttributeReport.vue?vue&type=style&index=0&id=1b6b69b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6b69b2",
  null
  
)

export default component.exports